<script>
import { defineComponent } from 'vue';

import StaticHomePage from '@/components/homepage/StaticHomePage.vue';

export default defineComponent({
  name: 'Theme404',
  props: {
    exception: { type: Object, required: false },
  },
  components: {
    StaticHomePage,
  },
  setup() {
    return {
      exceptionStyle: {
        backgroundColor: '#f8f8f8',
        color: '#000',
        border: '3px solid #fa0',
        borderRadius: '8px',
        overflow: 'scroll',
        padding: '0.5em 0.75em',
      },
      characterImagePath: nutshell['img/walnut-character.svg'],
    };
  },
  metaInfo: {
    title: 'Not Found',
    // delete these without deleting any other meta or link tags:
    meta: [{ key: 'description' }],
    link: [{ key: 'canonical' }],
  },
});
</script>

<template>
  <div class="container theme-header">
    <div class="theme-404 section">
      <div class="row">
        <div class="col-sm-3 col-xs-4">
          <img :src="characterImagePath" alt />
        </div>
        <div class="col-sm-9 col-xs-8">
          <h1>Nuts!</h1>
          <p>We couldn’t find what you were looking for.</p>
          <p class="hidden-xs">
            Are we missing your favorite product?
            <a href="/contact">Let us know!</a>
          </p>
        </div>
      </div>
    </div>
    <div v-if="exception" class="row">
      <div class="col-sm-12 section">
        <div v-bind:style="exceptionStyle">
          <h2>Exception information:</h2>
          <p>
            <b>{{ exception.class }}:</b>
            {{ exception.message }}
          </p>

          <h2>Stack trace:</h2>
          <pre>{{ exception.stack_trace }}</pre>

          <h2>Request Parameters:</h2>
          <pre>{{ exception.request_parameters }}</pre>
        </div>
      </div>
    </div>
    <StaticHomePage />
  </div>
</template>
